import type { ChatFastAction } from "@do/shared-types";
import type { ForDoBotPayload } from "../types/common";

type DoBotMetadata = NonNullable<ForDoBotPayload["metadata"]>;

/**
 * The metadata sent to the chatbot with a user message: a typed text or a clicked button.
 *
 * It starts from the metadata of the previous message, minus what only belongs to one message
 * (`form`, `context`, `buttonTitle`, `buttonCuid`). A clicked button sends its title; one with a
 * payload also sends its first metadata entry and its `cuid`: the chatbot applies the button's
 * context actions from its own configuration, found by that `cuid` (DAS-2807). Solutions (URL,
 * phone, code) have no payload.
 */
export function buildSubmitMetadata(
  previousMetadata: DoBotMetadata | undefined,
  userMessage: string | ChatFastAction,
  { isStreamingEnabled }: { isStreamingEnabled: boolean }
): DoBotMetadata {
  const metadata: DoBotMetadata = {
    ...previousMetadata,
    buttonCuid: undefined,
    buttonTitle: undefined,
    form: undefined,
    isStreamingEnabled,
    context: {},
  };
  if (typeof userMessage === "string") return metadata;

  if (userMessage.title) metadata["buttonTitle"] = userMessage.title;
  if (!userMessage.payload) return metadata;

  return {
    ...metadata,
    ...userMessage.metadata?.[0],
    ...(userMessage.cuid ? { buttonCuid: userMessage.cuid } : {}),
  };
}
